import React from 'react'

import { SectionItem } from '../Section'
import { PhysicalAddress } from './../../PhysicalAddress'

export interface PhysicalAddressProps {
  vm?: PhysicalAddress
}

export function PhysicalAddressSectionItems({ vm }: PhysicalAddressProps) {
  return (
    <>
      <SectionItem
        label="Address line 1"
        value={vm?.addressLine1}
        isSensitive
      />
      {vm?.addressLine2 && (
        <SectionItem
          label="Address line 2"
          value={vm.addressLine2}
          isSensitive
        />
      )}
      <SectionItem label="City" value={vm?.city} />
      <SectionItem
        label="ZIP / Postal code"
        value={vm?.postalCode}
        isSensitive
      />
      <SectionItem label="State" value={vm?.region} isSensitive />
      <SectionItem label="Country" value={vm?.country} isSensitive />
    </>
  )
}
